import { useTheme } from '@/hooks/use-theme';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';

const themes = [
  {
    key: 'light' as const,
    name: '浅色主题',
    desc: '天鸿智算 simple-large 风格，浅色背景、深色文字、低对比度边框，适合明亮环境使用。',
    preview: {
      background: '#fafafa',
      foreground: '#191919',
      card: '#f5f5f5',
      primary: '#0a0a0a',
      border: '#e5e5e5',
      sidebar: '#f5f5f5',
    },
  },
  {
    key: 'dark' as const,
    name: '深色主题',
    desc: '8789 统一后端风格，深蓝黑背景、蓝色主色高亮，适合暗光环境使用。',
    preview: {
      background: '#111318',
      foreground: '#f7f8ff',
      card: '#1d202a',
      primary: '#2876f5',
      border: '#33394a',
      sidebar: '#1b1e27',
    },
  },
];

export function ThemeTab() {
  const { theme, setTheme } = useTheme();

  return (
    <Card>
      <CardHeader>
        <CardTitle>主题设置</CardTitle>
        <CardDescription>选择系统主题，切换后即时生效，下次打开自动保留。</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {themes.map((t) => {
            const active = theme === t.key;
            return (
              <button
                key={t.key}
                onClick={() => setTheme(t.key)}
                className={`group relative flex flex-col overflow-hidden rounded-xl border-2 text-left transition-all ${
                  active
                    ? 'border-foreground shadow-md'
                    : 'border-border hover:border-muted-foreground/50'
                }`}
              >
                {/* 预览色块 */}
                <div className="flex h-28 items-center justify-center gap-3 p-4" style={{ backgroundColor: t.preview.background }}>
                  <div
                    className="flex h-14 w-14 items-center justify-center rounded-lg text-sm font-bold shadow-sm"
                    style={{ backgroundColor: t.preview.primary, color: t.preview.background }}
                  >
                    M
                  </div>
                  <div className="flex flex-col gap-2">
                    <div
                      className="h-2 w-20 rounded"
                      style={{ backgroundColor: t.preview.foreground, opacity: 0.8 }}
                    />
                    <div
                      className="h-2 w-14 rounded"
                      style={{ backgroundColor: t.preview.foreground, opacity: 0.4 }}
                    />
                    <div className="flex gap-1.5">
                      <div
                        className="h-1.5 w-6 rounded"
                        style={{ backgroundColor: t.preview.card, border: `1px solid ${t.preview.border}` }}
                      />
                      <div
                        className="h-1.5 w-6 rounded"
                        style={{ backgroundColor: t.preview.card, border: `1px solid ${t.preview.border}` }}
                      />
                    </div>
                  </div>
                </div>
                {/* 信息区 */}
                <div className="flex flex-col gap-1.5 p-4">
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-semibold">{t.name}</span>
                    {active && (
                      <span className="flex h-5 items-center rounded-full bg-primary px-2 text-[11px] font-medium text-primary-foreground">
                        当前
                      </span>
                    )}
                  </div>
                  <p className="text-xs leading-relaxed text-muted-foreground">{t.desc}</p>
                </div>
              </button>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}